module.exports = __webpack_public_path__ + "static/media/Farmers-on-the-frontline-desktop.75464c3d.jpg";